import { c as _c } from "react/compiler-runtime";
import { GOTHAM_DISPLAY } from '@cc-shopping/ui/theme';
import { Typography, type TypographyProps } from '@mui/material';
import { Box } from '@mui/system';
import type { ComponentDriver } from '../product-card/types';
import type { ApprovalOddsAnalytics, Odds } from '.';
import { ApprovalOddsButton } from './ApprovalOddsButton';
import { TransUnionLink } from './TransUnionLink';
import { getOddsLabel } from './utils';
export type ApprovalOddsTextContentProps = {
  userCreditScore: number | undefined;
  odds: Odds;
  analytics?: ApprovalOddsAnalytics;
  isAmexOffer?: boolean;
  showBCCVariant?: boolean;
  hideOddsButton?: boolean;
  hideTooltip?: boolean;
  firePageActionOnClick?: boolean;
  typographyProps?: TypographyProps;
};
export const ApprovalOddsTextContent = t0 => {
  const $ = _c(29);
  const {
    userCreditScore,
    odds,
    showBCCVariant,
    analytics,
    isAmexOffer,
    hideOddsButton,
    hideTooltip,
    firePageActionOnClick,
    typographyProps
  } = t0;
  let t1;
  if ($[0] !== odds.max || $[1] !== odds.min) {
    t1 = getOddsLabel(odds.min, odds.max);
    $[0] = odds.max;
    $[1] = odds.min;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const oddsLabel = t1;
  let label = showBCCVariant && userCreditScore ? `(${odds.min}-${odds.max})` : `(${oddsLabel})`;
  if (isAmexOffer) {
    label = !userCreditScore ? oddsLabel : `(${oddsLabel})`;
  }
  let t2;
  if ($[3] !== isAmexOffer || $[4] !== odds.max || $[5] !== odds.min || $[6] !== typographyProps || $[7] !== userCreditScore) {
    t2 = !userCreditScore && !isAmexOffer && <Typography variant="text" sx={{
      display: "inline"
    }} {...typographyProps}>{odds.min}-{odds.max}</Typography>;
    $[3] = isAmexOffer;
    $[4] = odds.max;
    $[5] = odds.min;
    $[6] = typographyProps;
    $[7] = userCreditScore;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== showBCCVariant || $[10] !== typographyProps || $[11] !== userCreditScore) {
    t3 = userCreditScore && <><Typography variant="text" sx={{
        display: "inline"
      }} {...typographyProps}>{userCreditScore * 850}</Typography><TransUnionLink forceMobile={showBCCVariant} /></>;
    $[9] = showBCCVariant;
    $[10] = typographyProps;
    $[11] = userCreditScore;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      display: "inline"
    };
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const t5 = isAmexOffer ? 0 : "0.25rem";
  let t6;
  if ($[14] !== label || $[15] !== t5 || $[16] !== typographyProps) {
    t6 = <Typography variant="text" sx={t4} marginLeft={t5} {...typographyProps}>{label}</Typography>;
    $[14] = label;
    $[15] = t5;
    $[16] = typographyProps;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== analytics || $[19] !== firePageActionOnClick || $[20] !== hideOddsButton || $[21] !== hideTooltip || $[22] !== userCreditScore) {
    t7 = !userCreditScore && !hideOddsButton && <ApprovalOddsButton analytics={analytics} hideTooltip={hideTooltip} firePageActionOnClick={firePageActionOnClick} />;
    $[18] = analytics;
    $[19] = firePageActionOnClick;
    $[20] = hideOddsButton;
    $[21] = hideTooltip;
    $[22] = userCreditScore;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] !== t2 || $[25] !== t3 || $[26] !== t6 || $[27] !== t7) {
    t8 = <Box position="relative">{t2}{t3}{t6}{t7}</Box>;
    $[24] = t2;
    $[25] = t3;
    $[26] = t6;
    $[27] = t7;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  return t8;
};
export const DefaultApprovalOddsTextContentTypographyProps = {
  fontSize: {
    xs: '15px',
    md: '16px'
  },
  fontFamily: GOTHAM_DISPLAY,
  fontWeight: 500,
  lineHeight: '140%'
};
export function getDefaultApprovalOddsTextContentDriver(props: Omit<ApprovalOddsTextContentProps, 'typographyProps'>): ComponentDriver {
  return {
    id: 'recommendedCreditScore',
    label: props.isAmexOffer ? 'Recommended credit' : 'Recommended credit score',
    value: <ApprovalOddsTextContent {...props} typographyProps={DefaultApprovalOddsTextContentTypographyProps} />
  };
}